import Image from "next/image";
import React from "react";

import {useTwMediaQuery} from "../../../hooks/useTwMediaQuery";
import {Breakpoint} from "src/constants/breakpoint";

const Logo = () => {
  const isNotSmall = useTwMediaQuery(Breakpoint.SM);
  return (
    <Image
      src="/static/img/v5/logo.svg"
      height={isNotSmall ? 26 : 19}
      width={isNotSmall ? 187 : 137}
      alt="Carbon Health"
      className="absolute left-1/2 transform -translate-x-1/2" // so logo is always centered regardless of button widths around
    />
  );
};

export default React.memo(Logo);
